import * as HLF from "html-living-framework";
import { Application } from "../../Application";
import * as Constants from "../../Data/Constants";
import { ObstacleType } from "../../Data/Obstacles";
import { ProjectileToken } from "../../Data/ProjectileToken";
import * as SFX from "../../Data/SoundEffectKeys";
import * as Topics from "../../Data/Topics";
import { Obstacle } from "../../GameObjects/Obstacles/Obstacle";
import { BoxCollider } from "../../Physics/BoxCollider";

export class Paletas extends Obstacle {
    private static readonly SPEED: number = 0;
    private static readonly Y_POS: number = 250;
    private static readonly LAUNCH_THRESHHOLD: number = 350;
    private static readonly PROJ_OFFSET: PIXI.Point = new PIXI.Point(65, -30);
    private static readonly ANIM_KEY: string = "AnimKey";

    private _hasLaunched: boolean;

    private _base: PIXI.Sprite;
    private _anim: HLF.AnimatedSprite;

    constructor() {
        super(Paletas.SPEED, new BoxCollider());
        this._hasLaunched = false;

        this.position.y = Paletas.Y_POS;

        this._base = HLF.PixiUtils.makeSprite("paletas", Constants.SPRITESHEET_OBSTACLE_PREFIX + "00");
        this._base.anchor.set(0, 0.5);
        this.addChild(this._base);

        this._anim = new HLF.AnimatedSprite();
        this._anim.anchor.set(0, 0.5);
        this._anim.addAnimation(Paletas.ANIM_KEY, new HLF.SpriteAnimation(
            "paletas-lid-", Constants.SPRITESHEET_OBSTACLE_PREFIX + "00", 4, 2,
            12, false,
        ));
        this._anim.holdFrame(Paletas.ANIM_KEY, 0);
        this.addChild(this._anim);
    }

    public update(pDeltaTime: number): void {
        super.update(pDeltaTime);
        this._anim.update(pDeltaTime);

        if (this._hasLaunched === false && this.position.x < Paletas.LAUNCH_THRESHHOLD) {
            this.launch();
        }
    }

    private launch(): void {
        this._hasLaunched = true;
        this._anim.play(Paletas.ANIM_KEY);
        PubSub.publishSync(Topics.SPAWN_PROJECTILE, new ProjectileToken(
            ObstacleType.PALETAS_PROJECTILE,
            HLF.PointUtils.add(this.position, Paletas.PROJ_OFFSET),
        ));
        Application.instance.audio.play(SFX.PALETA_LAUNCH, 1, false, HLF.AudioCategory.SFX);
    }
}
